// extracted by mini-css-extract-plugin
export default {"title":"BudgetSubDivTitle_title__npPW0"};